import LegalDisciplinaryHistory from './LegalDisciplinaryHistory';
export { LegalDisciplinaryHistory };
export default LegalDisciplinaryHistory;
